import { PayloadAction } from '@reduxjs/toolkit';
import { QUOTE_LINE_INFO_TABS } from '@ui/config/price/constants';
import { WritableDraft } from 'immer';

import { QuoteBuilderStateType } from '../../types/state';
import { getQuoteLineOrThrow } from '../utilities/action-guards';
import { QuoteLineParams } from './types';

export function costEstimatorOpened(
  state: WritableDraft<QuoteBuilderStateType>,
  action: PayloadAction<QuoteLineParams>,
) {
  const quoteLine = getQuoteLineOrThrow(state, action.payload.quoteLineUuid);

  quoteLine.isInfoVisible = true;
  quoteLine.infoTab = QUOTE_LINE_INFO_TABS.COST_ESTIMATOR;
}
